<template>
  <div :style="{ backgroundColor: theme.screenBackgroundColor.value }" class="message-screen">
    <header class="header" :style="{ backgroundColor: theme.headerBackgroundColor.value }">
      <h1 class="header-title" :style="{ color: theme.headerTextColor.value }">{{this.$props.venue.venue_name}}</h1>
    </header>

    <div class="message-list">
      <div
        class="message-item"
        v-for="(item, index) in messages"
        :key="index"
        :style="{ backgroundColor: theme.displayInfoBackground.value }"
      >
        <div class="icon-box" :style="{ backgroundColor: theme.infoIconColor.value }">
          <span class="icon">💬</span>
        </div>
        <div class="message-content">
          <h3 class="msg-title" :style="{ color: theme.PrimaryTextColor.value }">{{ item.title }}</h3>
          <p class="msg-subtitle" :style="{ color: theme.SecondaryTextColor.value }">{{ item.subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessagePreview',
  props: ['theme','venue'],
  data() {
    return {
      messages: [
        { title: 'Security', subtitle: 'Text Security about an issue' },
        { title: 'Address', subtitle: "Let friends know where you're at" },
        { title: 'Club Chat', subtitle: 'Coming Soon!' }
      ]
    };
  }
};
</script>

<style scoped>
.message-screen {
  padding: 16px;
  min-height: 100vh;
}

.header {
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.message-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-item {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.icon-box {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.icon {
  color: white;
  font-size: 24px;
}

.message-content {
  flex: 1;
}

.msg-title {
  font-size: 16px;
  margin: 0 0 4px 0;
  font-weight: bold;
}

.msg-subtitle {
  font-size: 13px;
  margin: 0;
}
</style>